module.exports = __webpack_public_path__ + "img/hontai_DarkBlue.79d48f35.png";